import * as React from "react";
const ObjectPositionRightSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 8h7v1H2V8Zm14 .5a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 5 0Zm-1 0c0-.83-.67-1.5-1.5-1.5S12 7.67 12 8.5s.67 1.5 1.5 1.5S15 9.33 15 8.5Z" }));
ObjectPositionRightSmall.displayName = "ObjectPositionRightSmall";
var ObjectPositionRightSmall_default = ObjectPositionRightSmall;
export {
  ObjectPositionRightSmall_default as default
};
